import { Order } from '@/generated/gql/graphql';

export enum OrderDataGridField {
  EXTERNAL_ID = 'externalId',
  ORDER_CREATION_DATE = 'orderCreationDate',
  ORDER_VOLUME = 'orderVolume',
  SUPPLIER_NAME = 'supplierName',
  SUPPLIER_EXTERNAL_ID = 'supplierExternalId',
  SUPPLIER_EMPLOYEE_COUNT = 'supplierEmployeeCount',
  SUPPLIER_INDUSTRY = 'supplierIndustry',
  SUPPLIER_LEGAL_TYPE = 'supplierLegalType',
  SUPPLIER_ADDRESS = 'supplierAddress',
  REPRESENTATIVE_COUNT = 'representativeCount',
  CONTRACT_CREATION_DATE = 'contractCreationDate',
  CONTRACT_VALID_FROM = 'contractValidFrom',
  CONTRACT_VALID_TO = 'contractValidTo',
  CONTRACT_RECEIVED_PROPOSALS_COUNT = 'contractReceivedProposalsCount',
  CONTRACT_AVERAGE_VALUE_CONTRIBUTION = 'contractAverageValueContribution',
  ORDER_PRODUCT_COUNT = 'orderProductCount',
  ORDER_PRODUCT_CATEGORY_COUNT = 'orderProductCategoryCount',
  ORDER_SERVICE_COUNT = 'orderServiceCount',
  PRIMARY_COMMODITY_GROUP = 'primaryCommodityGroupId',
  COMMODITY_GROUP_LIST = 'commodityGroupList',
  COMMODITY_GROUP_COUNT = 'commodityGroupCount',
  LINKS = 'links',
}

export enum OrderDataGridColumnGroup {
  CONTRACT = 'contract',
  SUPPLIER = 'supplier',
  PRODUCT = 'product',
  SERVICE = 'service',
  ORDER = 'order',
}

export type OrderDataGridRow = Order;
